import { useGlobalProperties } from '@/src/composables/useGlobalProperties';

export default function useContactUs() {
  const { getGlobalProperties } = useGlobalProperties();
  const { $api, $router, $toast } = getGlobalProperties();

  if (!$api) {
    console.error('API instance is not available');
  }

  const redirectToInbox = () => {
    $api
      .get('/api/user/inbox/find/subadmin')
      .then((res: any) => {
        $router.push({ path: '/dashboard/inbox', query: { id: res.data.id, from_contact: 'true' } });
      })
      .catch((err: any) => {
        $toast({
          message: `Failed to find support user`,
          type: 'error',
        });
        console.error(err);
      });
  };

  return {
    redirectToInbox,
  };
}
